import React from 'react';
import { withRouter } from 'react-router';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import CheckCircle from '@zg-rentals/multibrand-ui/lib/icons/CheckCircle';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import ModalActions from 'app/shared/actions/ModalActions';

import './style.scss';

const PostDeactivationModal = ({
    dispatch, paths, location,
}) => {
    const handleCollectRentClick = () => {
        const { pathname } = location;
        const listingId = pathname.split('/')[3];
        const paymentsPathname = `${paths.base}/payments/properties/${listingId}`;

        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.POST_DEACTIVATION_MODAL_COLLECT_RENT_CLICK
        ));

        const params = '?itc=ZRM_Listing_Deactivated_Modal&acceptTerms=true';
        const onboardingPath = `${paymentsPathname}/onboarding/payment-settings${params}`;
        window.router.updateLocation(onboardingPath);
    };

    const handleDontNeedClick = () => {
        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.POST_DEACTIVATION_MODAL_DONT_NEED_CLICK
        ));
        dispatch(ModalActions.hideModal());
    };

    return (
        <div className="PostDeactivationModal-Content">
            <div className="PostDeactivationModal-Content-primary">
                <CheckCircle colorType="marketing" size={100} />
                <SpacerRow>
                    <Text type="h2">Your listing is deactivated</Text>
                </SpacerRow>
                <SpacerRow>
                    <Text type="body">We are removing your listing from Zillow, Trulia and HotPads.</Text>
                </SpacerRow>
            </div>
            <div className="PostDeactivationModal-Content-secondary">
                <SpacerRow>
                    <Text type="h3">Now make sure you&#39;re paid on time!</Text>
                </SpacerRow>
                <SpacerRow>
                    <Text type="body">
                        Collect rent online with Zillow Rental Manager. It&#39;s easy, quick and free.
                    </Text>
                </SpacerRow>
                <SpacerRow>
                    <Button full={true} type="primary" onClick={handleCollectRentClick}>
                        Start collecting rent
                    </Button>
                </SpacerRow>
                <SpacerRow>
                    <Text lowlight={true} type="body-tiny">
                        By clicking &quot;Start collecting rent&quot; you agree to comply with the&nbsp;
                        <Link href={paths.corpTermsURL} type="secondary" target="_blank">
                            Terms of Use
                        </Link>
                        ,&nbsp;
                        <Link href={paths.rentalTermsURL} type="secondary" target="_blank">
                            Rental User Terms
                        </Link>
                        , and our third-party payment processor&apos;s&nbsp;
                        <Link href={paths.paymentTermsURL} type="secondary" target="_blank">
                            Payment Terms
                        </Link>
                        &nbsp;and
                        <Link href={paths.bankAuthorizationTermsURL} type="secondary" target="_blank">
                            &nbsp;Bank Authorization Terms
                        </Link>
                        .
                    </Text>
                </SpacerRow>
            </div>
            <SpacerRow>
                <Link type="secondary" onClick={handleDontNeedClick}>
                    I don&#39;t need online rent payments at this time
                </Link>
            </SpacerRow>
        </div>
    );
};

export default withRouter(PostDeactivationModal);
